import * as _ from 'lodash';
import config from '@/config';

var mutex = new MutexPromise (config.api.mutexKey, {
    timeout: 1000 * 60
});

export default class Api
{
    static async get (path, params)
    {
        return this.request (
            'GET', path, params
        );
    }

    static async post (path, body)
    {
        return this.request (
            'POST', path, body
        );
    }

    static async upload (path, file, progress)
    {
        let url,
            form,
            xhr,
            apiReady;

        url      = this.getUrl (path);
        progress = progress || (() => {});

        mutex.lock ();
        apiReady = mutex.promise ();
        mutex.unlock ();

        return apiReady.then ((mutex) => {
            mutex.lock ();

            return new Promise ((resolve, reject) => {
                xhr = new XMLHttpRequest ();

                xhr.upload.addEventListener ('progress', (e) => {
                    let uploaded, total;

                    uploaded = e.position  || e.loaded;
                    total    = e.totalSize || e.total;

                    progress (
                        Math.floor (uploaded / total * 1000) / 10
                    );
                });

                xhr.onreadystatechange = () => {
                    if (xhr.readyState !== 4) {
                        return;
                    }

                    mutex.unlock ();

                    if (xhr.status < 400) {
                        resolve (xhr);
                    } else {
                        reject (xhr);
                    }
                };

                xhr.onerror = () => {
                    mutex.unlock ();
                    reject (xhr.response, xhr.status, xhr);
                };

                form = new FormData ();
                form.append ('file', file);

                xhr.open ('POST', url);
                xhr.send (form);
            });
        });
    }

    static async request (method, path, params)
    {
        let init = {},
            url  = null,
            req  = null;

        params = params || {};

        init = {
            method,
            headers: new Headers ()
        };

        url = new URL (
            this.getUrl (path)
        );

        switch (method) {
            case 'GET':
                if (!_.isEmpty (params) || params instanceof FormData) {
                    url.search = new URLSearchParams (params);
                }
            break;

            case 'POST':
                init.body = params;
            break;
        }

        req = new Request (url, init);

        return new Promise ((resolve, reject) => {
            fetch (req)

            .then (res => {
                if (res.status >= 400) {
                    return reject (res);
                }

                return resolve (res);
            })

            .catch (reject);
        });
    }

    static getUrl (path)
    {
        return `${config.api.protocol}://${config.api.host}:${config.api.port}${config.api.base}${path}`;
    }
}